module.exports = __webpack_public_path__ + "media/audio37.480de9d5.mp3";